import React from 'react';
import { PasswordForgetForm } from '../PasswordForget';
import PasswordChangeForm from '../PasswordChange';
import { AuthUserContext, withAuthorization } from '../Session';
import CustomNavBar from '../CustomNavBar';
import SignOut from '../SignOut';


class FavoriteSites extends React.Component{ 

  render (){ return(
      <AuthUserContext.Consumer>
      {authUser => (
        <div style={{paddingTop:  '10rem'}}>
           <CustomNavBar onClick={i => this.handleClick(i)} showButton = {this.props.showButton} />
           <h1>Favorite Sites</h1>

        </div>
        )}
        </AuthUserContext.Consumer>
      );
  }

}


const condition = authUser => !!authUser;
export default withAuthorization(condition)(FavoriteSites);